// Piezas comunes del sistema visual (UI-1): la insignia del estado del backend de una pantalla y el
// aviso de función no disponible. Las usa TODO el ERP: ningún módulo inventa su propia versión.
import type { ReactNode } from 'react';
import { NOMBRE_ESTADO, type EstadoBackend } from '../shell/navegacion';
import { useModoRevision } from '../shell/salud';

/** A/B/C del backend de una pantalla. Solo en VALIDACIÓN/DEV: en producción no se ve. */
export function InsigniaBackend({ estado }: { estado: EstadoBackend }) {
  const revision = useModoRevision();
  if (!revision) return null;
  return (
    <span
      className={`insignia-backend estado-${estado}`}
      data-backend={estado}
      aria-hidden
      title={`${estado} · ${NOMBRE_ESTADO[estado]} (solo se ve en VALIDACIÓN/DEV)`}
    >
      {estado}
    </span>
  );
}

/**
 * Una función que todavía no opera (sin backend o sin fuente). Se ve qué falta; el botón queda
 * deshabilitado. Nunca simula éxito.
 */
export function NoDisponible({
  titulo,
  motivo,
  children,
}: {
  titulo: string;
  motivo: string;
  children?: ReactNode;
}) {
  return (
    <div className="no-disponible" role="note" aria-label={`${titulo}: no disponible`}>
      <b>{titulo}</b>
      <span className="motivo">{motivo}</span>
      {children}
    </div>
  );
}

/** Tesorería sin cartera: lo dice en grande y bloquea lo que dependa de ella. */
export function SinFuente({ detalle }: { detalle?: string }) {
  return (
    <div className="sin-fuente" role="alert" data-sin-fuente>
      <b>SIN FUENTE OPERACIONAL</b>
      <span>
        {detalle ??
          'Esta información todavía no existe en el ERP. No se muestran datos ni se permiten acciones que dependan de ella.'}
      </span>
    </div>
  );
}
